import { useState } from 'react';
import { Public } from '../api.js';
import { FormField } from '../components/FormField.jsx';
import { PageHeader } from '../components/PageHeader.jsx';

const empty = {
  name: '',
  email: '',
  phone: '',
  start: '',
  end: '',
  purpose: '',
  guestCount: 20,
  notes: '',
};

export default function Rent() {
  const [form, setForm] = useState(empty);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  async function submit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await Public.clubhouseInquiry({
        ...form,
        guestCount: Number(form.guestCount),
        start: new Date(form.start).toISOString(),
        end: new Date(form.end).toISOString(),
      });
      setDone(true);
    } catch (e) {
      setErr(e.data?.issues ? e.data.issues.map((i) => i.message).join(', ') : e.message);
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="max-w-lg mx-auto mt-16 md:mt-24 px-4 text-center">
        <div className="eyebrow text-brand mb-3">Inquiry received</div>
        <h1 className="font-display text-5xl mb-5">We'll be in touch.</h1>
        <p className="text-ink-2">We'll review availability and send a quote + payment link by email.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-6 py-8 md:py-12">
      <PageHeader
        eyebrow="Clubhouse"
        title="Rent the clubhouse."
        description="Birthdays, wakes, watch-alongs, weddings. Holds 120."
      />
      <form onSubmit={submit} className="card space-y-5">
        <FormField label="Your name" required>
          <input className="input" value={form.name} onChange={(e) => update('name', e.target.value)} required />
        </FormField>
        <div className="grid sm:grid-cols-2 gap-4">
          <FormField label="Email" required>
            <input type="email" className="input" value={form.email} onChange={(e) => update('email', e.target.value)} required />
          </FormField>
          <FormField label="Phone">
            <input className="input" value={form.phone} onChange={(e) => update('phone', e.target.value)} />
          </FormField>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <FormField label="Start" required>
            <input type="datetime-local" className="input" value={form.start} onChange={(e) => update('start', e.target.value)} required />
          </FormField>
          <FormField label="End" required>
            <input type="datetime-local" className="input" value={form.end} onChange={(e) => update('end', e.target.value)} required />
          </FormField>
        </div>
        <FormField label="Purpose" required hint="Birthday, meeting, watch-along, etc.">
          <input className="input" value={form.purpose} onChange={(e) => update('purpose', e.target.value)} required />
        </FormField>
        <FormField label="Expected guests" required>
          <input type="number" min={1} max={300} className="input" value={form.guestCount} onChange={(e) => update('guestCount', e.target.value)} required />
        </FormField>
        <FormField label="Notes" hint="Catering, AV, alcohol, special requests…">
          <textarea rows={3} className="input" value={form.notes} onChange={(e) => update('notes', e.target.value)} />
        </FormField>
        {err && <p className="text-sm text-danger">{err}</p>}
        <button type="submit" className="btn-primary w-full h-11" disabled={busy}>
          {busy ? 'Sending…' : 'Submit inquiry'}
        </button>
        <p className="text-[11px] text-ink-3 text-center">
          Your date isn't confirmed until payment is received.
        </p>
      </form>
    </div>
  );
}
